import ContentEditor from "./ContentEditor";

export default function DescriptionSection({
	descriptionFields,
	register,
	control,
	errors,
	descriptionRemove,
}) {
	return (
		<>
			{descriptionFields?.map((field, index) => {
				return (
					<div
						className="border border-1 border-light rounded-3 mt-2 bg-light"
						key={index}
					>
						<div className="">
							<div className="card-body">
								<div className="row">
									<div className="col">
										<div className="form-item">
											<label htmlFor="descriptionAr">
												عنوان الوصف باللغة العربية
											</label>
											<input
												type="text"
												{...register(`descriptions.${index}.title.ar`)}
											/>
										</div>
									</div>
									<div className="col">
										<div className="form-item">
											<label htmlFor="descriptionAr">
												عنوان الوصف باللغة الانجليزية
											</label>
											<input
												type="text"
												{...register(`descriptions.${index}.title.en`)}
											/>
										</div>
									</div>
								</div>
								<div className="row">
									<div className="form-item col-12 col-xl-6">
										<label htmlFor="descriptionAr">الوصف باللغة العربية</label>
										{/* <input
												type="text"
												name="ar"
												id="descriptionAr"
												{...register(`descriptions.${index}.ar`)}
											/> */}
										<ContentEditor
											name={`descriptions.${index}.desc`}
											locale={"ar"}
											control={control}
											errors={errors}
											key={index}
										/>
										{errors?.descriptions?.[index]?.desc?.ar&&<p className="error-hint text-danger">{errors?.descriptions?.[index]?.desc?.ar.message}</p>}
									</div>
									<div className="form-item col-12 col-xl-6">
										<label htmlFor="descriptionEn">
											الوصف باللغة الانجليزية
										</label>
										{/* <input
												type="text"
												name="en"
												id="descriptionEn"
												{...register(`descriptions.${index}.en`)}
											/> */}
										{/* <ContentEditor
												name={`descriptions.${index}`}
												locale={"ar"}
											/> */}
										<ContentEditor
											name={`descriptions.${index}.desc`}
											locale={"en"}
											// {...register(`descriptions.${index}.en`)}
											control={control}
											errors={errors}
											key={index}
											/>
											{errors?.descriptions?.[index]?.desc?.en&&<p className="error-hint text-danger">{errors?.descriptions?.[index]?.desc?.en.message}</p>}
									</div>
								</div>
							</div>
						</div>
						<div>
							<div className="card-body">
								<div className="form-item mt-3">
									<div
										className="bt bt-danger btn-block secBtnForm"
										type="button"
										onClick={() => descriptionRemove(index)}
									>
										احذف ذلك الوصف
									</div>
								</div>
							</div>
						</div>
					</div>
				);
			})}
		</>
	);
}
